import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconZip: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="zip, rar, compressed, archive"><path d="M6.25 3.75L3.75005 3.75001L3.75 20.25H20.25V3.75H17.75M9.75 3.75H14.25M9.75 7.75H14.25M9.75 11.75H14.25V14C14.25 15.2426 13.2426 16.25 12 16.25C10.7574 16.25 9.75 15.2426 9.75 14V11.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconZip;
